import Pages from '@opsbase/lib-pages';
import DeleteIcon from '@opsbase/web-icons/icons/DeleteIcon';
import EditIcon from '@opsbase/web-icons/icons/EditIcon';
import React from 'react';
import i18n from '@opsbase/lib-i18n';
import ItemMenu from '../../opsbase/menus/ItemMenu';
import CopyIcon from "@opsbase/web-icons/icons/CopyIcon";
import PublishIcon from "@opsbase/web-icons/icons/PublishIcon";
export function OrgTemplateMenu(props) {
    const { item, ...otherProps } = props;
    let options = [{
            icon: EditIcon,
            label: i18n.t('edit'),
            page: Pages.ORG_TEMPLATE_EDIT,
            variant: 'action',
        },
        {
            icon: CopyIcon,
            label: i18n.t('copy'),
            page: Pages.ORG_TEMPLATE_COPY,
            variant: 'action',
        },
    ];
    if (item.requiresRollOut) {
        options.push({
            icon: PublishIcon,
            label: i18n.t('rollout'),
            page: Pages.ORG_TEMPLATE_ROLLOUT,
            variant: 'good',
        });
    }
    options.push({
        icon: DeleteIcon,
        label: i18n.t('delete'),
        page: Pages.ORG_TEMPLATE_DELETE,
        variant: 'warn',
    });
    return (React.createElement(ItemMenu, { id: item.id, options: options, ...otherProps }));
}
export default OrgTemplateMenu;
